export default {
	type: 'conversationMessage',
	messageType: 'metadataExchange',
	metadataBag: null
}
